export enum AppPoolState {
    Started = 'Started',
    Stopped = 'Stopped',
}
